import React from "react";
import Icon from "@mdi/react";
import { mdiInformationOutline } from "@mdi/js";
import { hintVariantForNotice, LOCK_NOTICES } from "../utils/fieldLockRules";
import "./LockedField.css";

// The amber "Not editable after ..." line. Figma places it next to the section
// title when a whole section locks together (Appointment, Address) and directly
// under the control when a single field locks (Client Name, Quote, Contract).
export const LockNotice = ({ notice, className = "" }) => {
  const copy = LOCK_NOTICES[notice];
  if (!copy) return null;

  return (
    <span className={`locked-field-notice ${className}`.trim()}>
      <Icon
        path={mdiInformationOutline}
        size="16px"
        className="locked-field-notice-icon"
      />
      <span>{copy}</span>
    </span>
  );
};

// Disables the controls it wraps and turns a click on them into the unlock hint.
// A native disabled <input> swallows its own click events, so the transparent
// overlay is what makes "click a locked field to learn how to unlock it" work.
// Omit onLockClick for locks with no unlock path (e.g. inspection already started).
const LockedField = ({ notice, onLockClick, showNotice = true, children }) => {
  if (!notice) return <>{children}</>;

  return (
    <>
      <div className="locked-field">
        {onLockClick && (
          <button
            type="button"
            className="locked-field-overlay"
            aria-label="Locked field. Show how to unlock it."
            onClick={() => onLockClick(hintVariantForNotice(notice))}
          />
        )}
        <fieldset disabled className="locked-field-controls">
          {children}
        </fieldset>
      </div>
      {showNotice && (
        <LockNotice notice={notice} className="locked-field-notice--below" />
      )}
    </>
  );
};

export default LockedField;
